import React from 'react'
import {
    fileExt as fileExtConst,
    memorandumTopic,
    topicForLecturer,
    topicForStudent,
} from '../../../../../../constants/constants'
import useLookupService from '../../../../../../services/lookup/useLookupService'
import useWebService from '../../../../../../services/web/useWebService'
import * as resultOfConsiderType from './resultOfConsiderType'
import checkPermission from '../../../../../../utilities/checkPermission'
import useLoading from '../../../../../../control/loading/useLoading'
import useAppFolderAndTabAction from '../../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import useTranslate from '../../../../../../i18n/useTranslate'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import authenStore from '../../../../../../stores/authen/authenStore'
// import * as REQServiceType from '../../../../../services/web/types/requestWebServiceTypes'

import _ from 'lodash'
import { DialogType } from '../../../../../../control/dialog/dialog'
import { requestWebServiceTypes } from '../../../../../../services/web/types'
import { RoutePath } from '../../../../../../router/routesConfig'
import { useHistory } from 'react-router-dom'
import {
    DocumentInfo,
    SynthesisReviewInfo,
    SynthesisReviewRemarkInfo,
} from '../../../../../../services/web/types/responseWebServiceTypes'
import path from 'path'
import useProjectHook from '../../../../shareLogic/useProjectHook'
import { SynthesisReviewProjectRequestType } from '../../../../../../services/web/types/requestWebServiceTypes'
import { UploadFileObjCerType } from '../../generateCertificate/generateCertificateType'

// import { fileExt as fileExtConst, topicForLecturer, topicForStudent } from '../../../../../../constants/constants'
const useSynthesisReview = (props: resultOfConsiderType.UseResultOfConsiderType) => {
    // const { projectData } = props
    const { callbackSaveComplete } = props
    const manageProjectStore = useManageProjectStore()
    const projectHook = useProjectHook()

    const projectData = manageProjectStore.projectData
    const loadingHook = useLoading()
    const translate = useTranslate()
    const callLookup = useLookupService()
    const callWebService = useWebService()
    const [initialValues, setInitialValues] = React.useState<any>({})
    // const defaultRemarkRef = React.useRef<string>()
    const checkPermissionHook = checkPermission()
    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const profileStore = authenStore()
    const { profile } = profileStore
    const [configDialog, setConfigDialog] =
        React.useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogRef = React.useRef<Record<string, Function>>()
    const history = useHistory()
    const [initialComment, setInitialComment] = React.useState<any>()
    const [synthesisReviewInfoList, setSynthesisReviewInfo] = React.useState<SynthesisReviewInfo[]>([])
    const [isLoadedSynthesisReview, setIsLoadedSynthesisReview] = React.useState<boolean>(false)
    const [synthesisReviewRemarkInfoList, setSynthesisReviewRemarkInfo] = React.useState<SynthesisReviewRemarkInfo>()
    const [documentInfoList, setDocumentInfo] = React.useState<DocumentInfo[]>([])
    const [approveStatus, setApproveStatus] = React.useState<resultOfConsiderType.ApproveType>()
    const [initialRichTextEditor, setInitialRichTextEditor] = React.useState<any>()
    const [initialRichRemark, setInitialRichRemark] = React.useState<any>()
    const [initialMemorandumFile, setInitialMemorandumFile] = React.useState<any>()

    React.useEffect(() => {
        getSynthesisReviewData()
        getSynthesisData()
    }, [projectData?.projectID ?? null, projectData?.submittedID ?? null])

    React.useEffect(() => {
        createInitialData()
        createInitialComment()
        createInitialRichTextEditor()
        createInitialRichRemark()
        createInitialMemorandumFile()
    }, [isLoadedSynthesisReview])

    React.useEffect(() => {
        createInitialComment()
    }, [translate.languageStore.currentLanguage])

    const onRefDialog = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogRef.current = func
    }

    // const handleDirtyChange = (props: any) => {
    //     let isDirty: boolean = false
    //     //** จัดformat initValue และ Form Value เพื่อเตรียมตัวนำไปใช้เปรียบเทียบค่า  **//
    //     let newFormValue = { ...props.values }
    //     let initValue = { ...initialValues }

    //     // console.log('newFormValue', newFormValue)
    //     // console.log('initValue', initValue)

    //     //**********************************************************//
    //     const isEqual = _.isEqual(initValue, newFormValue) //ข้อมูลเท่ากัน
    //     if (!isViewMode) {
    //         if (isEqual) {
    //             isDirty = false
    //         } else {
    //             isDirty = true
    //         }
    //     } else {
    //         isDirty = false
    //     }
    //     const paramsDirty = {
    //         tabDirty: isDirty,
    //         callbackDirty: callbackDirtyProcess,
    //     }
    //     appFolderAndTabAction.setDirty(paramsDirty)
    // }

    // const callbackDirtyProcess = (tabIndex: number, newTabSelected: any) => {
    //     // if (onSaveDirty) {
    //     //     onSaveDirty(formRenderPropsRef.current, tabIndex, newTabSelected)
    //     // }
    // }

    const getParameterForSave = (val: resultOfConsiderType.TFormValue) => {
        let paramForSave = null
        const projectID = manageProjectStore?.projectData?.projectID ?? null
        const submittedID = manageProjectStore?.projectData?.submittedID ?? null

        let isDraft = false
        if (val.submitType === 'draft') {
            isDraft = true
        }
        let isApproveWithCommentFlow
        if (manageProjectStore?.projectData) {
            // isEditAfterReview = projectHook.isEditAfterReview(manageProjectStore?.projectData)
            isApproveWithCommentFlow = projectHook.isFlowApproveWithComment(manageProjectStore?.projectData)
        }

        const isNotHaveStampFileList =
            val?.documentCertificate?.childSelected?.length === 0 &&
            val?.documentCertificate?.parentSelected?.length === 0

        if (isApproveWithCommentFlow) {
            const synthesisReviewProjectRequest: requestWebServiceTypes.SynthesisReviewApproveWithCommentType = {
                loginUserID: profileStore.profile.userId,
                submittedID: submittedID,
                // stampFileList: val.documentCertificate.childSelected.map((itm: any) => {
                //     return itm.fileID
                // }),
                stampFileList: isNotHaveStampFileList ? null : val.documentCertificate,
                isDraft: isDraft,
            }
            paramForSave = synthesisReviewProjectRequest
        } else {
            const synthesisReviewProjectRequest: requestWebServiceTypes.SynthesisReviewProjectRequestType = {
                loginUserID: profileStore.profile.userId,
                submittedID: submittedID,
                synthesisReviewInfo: val.commentDirector?.map((itm: any) => {
                    return {
                        commentaryTopicId: itm.id,
                        comment:
                            itm.consideration && itm.consideration.contentText ? itm.consideration.contentText : null,
                        comment_htmltag:
                            itm.consideration && itm.consideration.contentHtml ? itm.consideration.contentHtml : null,
                    }
                }),
                // stampFileList: val.documentCertificate.childSelected.map((itm: any) => {
                //     return itm.fileID
                // }),
                stampFileList: isNotHaveStampFileList ? null : val.documentCertificate,
                synthesisReviewRemarkInfo: {
                    remark: val.remark && val.remark.contentText ? val.remark.contentText : null,
                    remark_htmltag: val.remark && val.remark.contentHtml ? val.remark.contentHtml : null,
                },
                isDraft: isDraft,
            }
            paramForSave = synthesisReviewProjectRequest
        }

        // paramForSave = synthesisProjectRequest

        return paramForSave
    }

    const handleSubmitForm = async (val: resultOfConsiderType.TFormValue) => {
        const parameter = getParameterForSave(val)
        if (val.submitType === 'save') {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
                type: 'alert-confirm',
                onClickConfirm: () => {
                    handleConfirmSave(parameter)
                },
            })
            dialogRef.current?.openDialog()
        } else {
            //ถ้า save draft ไม่ต้องมี alert confirm
            handleConfirmSave(parameter)
        }
    }

    const handleConfirmSave = async (
        paramForSave:
            | requestWebServiceTypes.SynthesisReviewProjectRequestType
            | requestWebServiceTypes.SynthesisReviewApproveWithCommentType,
    ) => {
        let isApproveWithCommentFlow
        if (manageProjectStore?.projectData) {
            // isEditAfterReview = projectHook.isEditAfterReview(manageProjectStore?.projectData)
            isApproveWithCommentFlow = projectHook.isFlowApproveWithComment(manageProjectStore?.projectData)
        }
        dialogRef.current?.closeDialog()

        const isDraft = paramForSave.isDraft ? paramForSave.isDraft : false
        loadingHook.loadingOpen()
        let res
        if (isApproveWithCommentFlow) {
            const param = { ...paramForSave } as SynthesisReviewProjectRequestType
            res = await callWebService.synthesisReviewApproveWithCommentProject(param)
        } else {
            const param = { ...paramForSave } as requestWebServiceTypes.SynthesisReviewProjectRequestType
            res = await callWebService.synthesisReviewProject(param)
        }

        loadingHook.loadingClose()
        if (callbackSaveComplete) {
            if (res && res.status) {
                callbackSaveComplete(res.status, isDraft)
            }
        }
    }

    const handleClickCancel = (dirty: boolean) => {
        if (dirty) {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.WARNING'),
                content: translate.get('ALERT.CONTENT.NEED_TO_CANCEL'),
                type: 'alert-confirm',
                onClickConfirm: () => {
                    history.push(RoutePath.manageProject)
                },
            })
            dialogRef.current?.openDialog()
        } else {
            history.push(RoutePath.manageProject)
        }
    }

    const getSynthesisData = async () => {
        if (projectData?.submittedID) {
            loadingHook.loadingOpen()
            const submittedID = projectData.submittedID
            const { result } = await callWebService.getSynthesisProjectByID(submittedID)
            loadingHook.loadingClose()

            if (result) {
                const approveStatus = {
                    id: result.approveStatusID,
                    nameTH: result.approveStatusName_th,
                    nameEN: result.approveStatusName_en,
                }
                setApproveStatus(approveStatus)
            }
        }
    }

    const getSynthesisReviewData = async () => {
        if (projectData?.submittedID) {
            setIsLoadedSynthesisReview(false)
            loadingHook.loadingOpen()
            const submittedID = projectData.submittedID
            const data = await callWebService.getSynthesisReview(submittedID)
            loadingHook.loadingClose()
            if (data.status === 1) {
                let documentInfo = [...data.result.documentInfo]
                documentInfo.forEach((itm) => {
                    const topicID = itm.topicID
                    let isCheckAll: boolean | null = null
                    itm.fileInfo.forEach((file) => {
                        file.topicID = topicID
                        if (path.extname(`${file.filename}`) === fileExtConst.pdf) {
                            if (file.isStamp && isCheckAll !== false) {
                                isCheckAll = true
                            } else {
                                isCheckAll = false
                            }
                        }
                    })
                    itm.isCheckAll = isCheckAll
                })
                //  BUG IS STAMP ออกมาเป็น false หมดเลย
                // setApproveStatus(data?.result?.approveStatusName_th)
                // setDocumentInfo(data.result.documentInfo)

                filterTopicUpload(documentInfo)
                // setDocumentInfo(documentInfo)
                setSynthesisReviewInfo(data.result.synthesisReviewInfo)
                setSynthesisReviewRemarkInfo(data.result.synthesisReviewRemarkInfo)
                setIsLoadedSynthesisReview(true)
            }
        }
    }

    const filterTopicUpload = (documentTopic: DocumentInfo[]) => {
        let docTopic: DocumentInfo[] = []
        const researcherTypeID = projectData?.researcherTypeInfo.value
        if (documentTopic) {
            let isDocTopic = documentTopic
            if (researcherTypeID === 1) {
                topicForLecturer.forEach((element) => {
                    docTopic = documentTopic?.filter((item: any) => {
                        return item.topicID !== element.id
                    })
                })
            } else {
                topicForStudent.forEach((element) => {
                    docTopic = isDocTopic?.filter((item: any) => {
                        return item.topicID !== element.id
                    })
                    isDocTopic = docTopic
                })
            }
            if (docTopic.length > 1) {
                docTopic = docTopic?.map((itm, index: number) => {
                    return { ...itm, topicNo: index + 1 }
                })
            }
            setDocumentInfo(docTopic)
        }
    }

    const createInitialComment = () => {
        const commentInit = synthesisReviewInfoList?.map((itm: any, idx: number) => {
            return {
                topic:
                    translate.languageStore.currentLanguage === translate.languageKey.th
                        ? itm.topicName_th
                        : itm.topicName_en,
                id: itm.topicID,
                no: itm.topicNo,
                commentList: itm.synthesisComment,
            }
        })
        setInitialComment(commentInit)
    }

    const createInitialData = () => {
        const { childSelectedList, parentSelectedList } = getInitialChildSelected()

        const initialData = {
            documentCertificate: {
                childSelected: childSelectedList,
                parentSelected: parentSelectedList,
            },
            commentRemarkList:
                synthesisReviewRemarkInfoList && synthesisReviewRemarkInfoList.synthesisRemark
                    ? synthesisReviewRemarkInfoList.synthesisRemark
                    : null,
            remarkList:
                synthesisReviewRemarkInfoList && synthesisReviewRemarkInfoList?.synthesisReviewRemark
                    ? synthesisReviewRemarkInfoList?.synthesisReviewRemark
                    : '-',
        }

        // const initialMemorandumFile = createInitialFileMemorandum(result.memoMessagePaperInfo)

        // setInitialMemorandumFile(initialMemorandumFile)
        setInitialValues(initialData)
    }

    const getInitialChildSelected = () => {
        let childSelectedList: any = []
        let parentSelectedList: any = []

        documentInfoList.forEach((documentItm) => {
            if (documentItm.fileInfo.length > 0) {
                documentItm.fileInfo.forEach((file) => {
                    if (file.isStamp) {
                        childSelectedList.push(file)
                    }
                })
            }
            if (documentItm.isCheckAll) {
                parentSelectedList.push(documentItm)
            }
        })

        return { parentSelectedList, childSelectedList }
    }

    const createInitialRichTextEditor = () => {
        const initialData = synthesisReviewInfoList.map((itm) => {
            return {
                contentHtml: itm.synthesisReviewCommentHtmlTag
                    ? itm.synthesisReviewCommentHtmlTag
                    : itm.synthesisComment,
                contentText: itm.synthesisReviewComment,
            }
        })

        setInitialRichTextEditor(initialData)
    }

    const createInitialRichRemark = () => {
        const initialData = {
            contentHtml: isViewMode
                ? synthesisReviewRemarkInfoList?.synthesisReviewRemark_html
                    ? synthesisReviewRemarkInfoList?.synthesisReviewRemark_html
                    : '-'
                : synthesisReviewRemarkInfoList?.synthesisReviewRemark_html
                ? synthesisReviewRemarkInfoList?.synthesisReviewRemark_html
                : synthesisReviewRemarkInfoList?.synthesisRemark,
            contentText: synthesisReviewRemarkInfoList?.synthesisReviewRemark,
        }

        setInitialRichRemark(initialData)
    }

    const createInitialMemorandumFile = async () => {
        const submittedID = manageProjectStore?.projectData?.submittedID ?? null

        if (submittedID) {
            const res = await callWebService.getProjectAmendmentMemoMessage(submittedID)
            const result = res.result

            // const initialMemorandumFile = createInitialFileMemorandum(result.memoMessagePaperInfo)

            // setInitialMemorandumFile(initialMemorandumFile)
            const memorandumInfo = result.memoMessagePaperInfo
            const uploadFileMemoranduminit: Array<UploadFileObjCerType> = memorandumTopic?.map(
                (itm: any, idx: number) => {
                    return {
                        uploadFileObj: {
                            fileList: [],
                            subTopicPageList: [],
                            documentTopicID: itm.id,
                        },
                    }
                },
            )
            uploadFileMemoranduminit.forEach((itm: UploadFileObjCerType) => {
                if (itm.uploadFileObj.documentTopicID === 0) {
                    if (memorandumInfo?.name_th) {
                        let fileListTH = {
                            documentTopicID: 0,
                            fileToken: memorandumInfo?.name_th,
                            filename: memorandumInfo?.name_th,
                            fileID: memorandumInfo?.name_th,
                            path: memorandumInfo?.signPathInfo?.path_th,
                        }
                        //@ts-ignore
                        itm.uploadFileObj.fileList.push(fileListTH)
                    }
                } else if (itm.uploadFileObj.documentTopicID === 1) {
                    if (memorandumInfo?.name_en) {
                        let fileListEN = {
                            documentTopicID: 1,
                            fileToken: memorandumInfo?.name_en,
                            filename: memorandumInfo?.name_en,
                            fileID: memorandumInfo?.name_en,
                            path: memorandumInfo?.signPathInfo?.path_en,
                        }
                        //@ts-ignore
                        itm.uploadFileObj.fileList.push(fileListEN)
                    }
                }

                itm.uploadFileObj.subTopicPageList = []
            })

            setInitialMemorandumFile(uploadFileMemoranduminit)
        }
    }

    return {
        approveStatus,
        initialValues,
        projectData,
        initialComment,
        documentInfoList,
        initialRichTextEditor,
        initialRichRemark,
        isViewMode,
        isFlowApproveWithComment: projectData ? projectHook.isFlowApproveWithComment(projectData) : false,
        configDialog,
        initialMemorandumFile,
        onRefDialog,
        onSubmitForm: handleSubmitForm,
        // handleDirtyChange: handleDirtyChange,
        onClickCancel: handleClickCancel,
    }
}

export default useSynthesisReview
